module.exports = __webpack_public_path__ + "media/images/newsletter-0f8c0cc9bccff5da0402fd5c98ff90a7.png";